import reframe from 'reframe.js'

const sources = [
  '.gh-content iframe[src*="youtube.com"]',
  '.gh-content iframe[src*="youtube-nocookie.com"]',
  '.gh-content iframe[src*="player.vimeo.com"]',
  '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
  '.gh-content object',
  '.gh-content embed',
]

export default function init() {
  reframe(document.querySelectorAll(sources.join(',')))
}
